export default CONFIG; /* global CONFIG */
